// src/components/CategoryCard.js
import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ category }) => {
  return (
    <Link
      to={`/category/${category.name?.toLowerCase().replace(/\s+/g, '-')}`}
      className="group flex flex-col items-center gap-3 transition-all duration-300 hover:-translate-y-1.5 anim-scaleIn"
    >
      <div
        className="relative w-20 h-20 md:w-28 md:h-28 lg:w-32 lg:h-32 rounded-full overflow-hidden shadow-lg transition-all duration-500 group-hover:shadow-2xl group-hover:scale-105"
        style={{
          border: `4px solid #FFFFFF`,
          outline: `2px solid #F5AEC0`,
          outlineOffset: '2px',
        }}
      >
        <img
          src={category.image || 'https://via.placeholder.com/200'}
          alt={category.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
      </div>

      <div className="text-center">
        <h3
          className="font-bold transition text-xs md:text-base group-hover:opacity-80 line-clamp-1 max-w-[100px] md:max-w-[120px]"
          style={{ color: '#9B3F5B' }}
        >
          {category.name}
        </h3>
        <p
          className="text-[10px] md:text-xs mt-0.5"
          style={{ color: '#DC829A' }}
        >
          {category.productCount || 0} {category.productCount === 1 ? 'Product' : 'Products'}
        </p>
      </div>
    </Link>
  );
};

export default CategoryCard;